export const normalizeErrorMessage = (error) => {
    if (typeof error === "string") return error.trim();
    if (Array.isArray(error)) {
        return error.map(normalizeErrorMessage).filter(Boolean).join("；");
    }
    if (error && typeof error === "object") {
        const nestedMessage = normalizeErrorMessage(error.message)
            || normalizeErrorMessage(error.error)
            || normalizeErrorMessage(error.description);
        if (nestedMessage) return nestedMessage;

        // CRUDController 會把純文字 HTTP 錯誤展開成以數字為 key 的物件。
        const keys = Object.keys(error);
        if (keys.length > 0 && keys.every((key) => /^\d+$/.test(key))) {
            return keys
                .sort((a, b) => Number(a) - Number(b))
                .map((key) => error[key])
                .join("")
                .trim();
        }
    }
    return "";
};

export const getItemRequestErrorMessage = (values, action, subject = "館藏") => {
    const prefix = `${subject}${action}失敗`;
    const errorMessage = normalizeErrorMessage(values?.message)
        || normalizeErrorMessage(values?.error)
        || normalizeErrorMessage(values?.description)
        || normalizeErrorMessage(values?.errors)
        || normalizeErrorMessage(values?.data)
        || normalizeErrorMessage(values);

    if (!errorMessage) {
        return `${prefix}：系統未回傳錯誤原因，請稍後再試或聯絡系統管理員`;
    }

    const isDuplicate = /already\s+exists?|already\s+been\s+taken|duplicate|unique\s+constraint|重複|已存在/i.test(errorMessage);
    const isBarcode = /barcode|external[_\s-]?id|條碼/i.test(errorMessage);

    if (isDuplicate && isBarcode) {
        return `${prefix}：條碼已存在資料庫中`;
    }
    if (/not\s+set|is\s+empty|required|missing|required\s+field|必填|未設定|不可為空/i.test(errorMessage)) {
        return `${prefix}：${subject}資料不完整（${errorMessage}）`;
    }
    if (/format\s+error|invalid|malformed|格式錯誤|格式不符|型別錯誤/i.test(errorMessage)) {
        return `${prefix}：${subject}資料格式錯誤（${errorMessage}）`;
    }
    if (/unauthorized|forbidden|permission|access\s+denied|權限不足|未授權/i.test(errorMessage)) {
        return `${prefix}：沒有執行此操作的權限`;
    }
    if (/timeout|timed\s+out|network|connection|couldn'?t\s+connect|連線|逾時/i.test(errorMessage)) {
        return `${prefix}：連線失敗或逾時，請稍後再試`;
    }
    if (/sqlstate|foreign\s+key|database|pdo|constraint|duplicate\s+key/i.test(errorMessage)) {
        return `${prefix}：${subject}資料寫入失敗，請聯絡系統管理員`;
    }
    if (/internal\s+server\s+error|fatal\s+error|undefined|exception|bad\s+gateway|service\s+unavailable|gateway\s+timeout|\b(500|502|503|504)\b/i.test(errorMessage)) {
        return `${prefix}：伺服器處理異常，請聯絡系統管理員`;
    }

    return `${prefix}：系統無法完成${subject}資料處理，請聯絡系統管理員`;
};
